import React from 'react';

import Feed from '@components/Feed';
import { ArticleOrBriefing } from '@components/Feed/ArticleOrBriefingFeedItem';

interface SearchArticlesListProps {
  content: ArticleOrBriefing[];
}

const SearchArticlesList = ({ content }: SearchArticlesListProps) => {
  return <Feed articlesOrBriefings={content} useLargeImage />;
};

export default SearchArticlesList;
